var React = require('react');

function LargeNext (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".bd91b1be-7e61-4d6a-bd6b-5e663896f6e9{fill:none;stroke-miterlimit:10;stroke-width:2px;}")),React.createElement("title",{"key":1},"large-next"),React.createElement("g",{"id":"beb46e15-c3c3-4fb2-945a-95260dafb0a0","data-name":"Layer 2","key":2},React.createElement("g",{"id":"f1bb39bc-dab8-44bf-ad7f-156f3f4231b4","data-name":"Page Content"},[React.createElement("polyline",{"className":"bd91b1be-7e61-4d6a-bd6b-5e663896f6e9","points":"34.43 0.71 61.86 28.14 34.53 55.73","key":0}),React.createElement("line",{"className":"bd91b1be-7e61-4d6a-bd6b-5e663896f6e9","x1":"59.76","y1":"28.16","y2":"28.16","key":1})]))]);
}

LargeNext.defaultProps = {"viewBox":"0 0 63.28 56.44"};

module.exports = LargeNext;

LargeNext.default = LargeNext;
